module.exports = __webpack_public_path__ + "static/media/withkids-over.8e618772.svg";